import z from "zod";

export const USCheckboxValueOptionsSchema = <T extends string>(keyOptions: readonly T[]) =>
  z.object({
    key: z.enum(keyOptions),
    checked: z.boolean().optional(),
  });
